import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useNavigate } from "react-router-dom";

const BackToScenariosButton = () => {
  const navigate = useNavigate();

  return (
    <Button
      startIcon={<ArrowBackIcon />}
      onClick={() => navigate("/vr/scenarios")}
      variant="outlined"
    >
      Powrót do listy
    </Button>
  );
};

export default BackToScenariosButton;
